export default {
  COMMON: {
    REJECT: 'Afvis',
    CONTINUE: 'Fortsæt',
    SIGN: 'Underskriv',
    LOADING: 'Indlæser...',
    VERIFY: 'Verificer',
    CANCEL: 'Annuller',
    VIEW: 'Vis',
    DOWNLOAD: 'Download',
    ATTACHMENTS: 'Vedhæftninger',
    DOCUMENTS: 'Dokumenter',
    READ: 'Læst',
    CHECKED: 'Tjekket',
  },

  APPROVER_INBOX: {
    TITLE: 'Ordreindbakke',
    SUBTITLE: 'Vælg de ordrer, du vil underskrive.',
    SELECT_ALL: 'Markér alle ordrer',
    SELECT_ALL_ORDERS: 'Markér alle ordrer',
    LOADING: 'Indlæser indbakke...',
    EMPTY: 'Ingen ordrer fundet.',
    EMPTY_TITLE: 'Ingen underskriftsordrer til godkendelse',
    EMPTY_SUBTITLE: 'Der er i øjeblikket ingen underskriftsordrer, der venter på din godkendelse.',
    ERROR_LOAD: 'Kunne ikke indlæse indbakken.',
    UNKNOWN_SENDER: 'Ukendt afsender',
    SENT_YOU_FILES: 'sendte dig dokumenter til underskrift',
    VIEW_FILE: 'Se fil',
    REJECT_ORDER: 'Afvis ordre',
    REVIEW_SELECTED: 'Gennemse valgte ({{count}})',
    EXPAND: 'Udfold',
    COLLAPSE: 'Sammenfold',
    CREATED: 'Oprettet',
    ONE_FILE: '1 fil',
    MANY_FILES: 'dokumenter',
    MORE: 'Flere',
    COPY_HASHSUM: 'Kopiér hashsum',
  },
  APPROVER_SIGN: {
    TITLE: 'Aftaledokumenter til underskrift',
    INSTRUCTION: 'Jeg har læst og accepterer indholdet af følgende aftaledokumenter. Når jeg har underskrevet aftalerne, er de bindende for mig.',
  },
  TAB_DETECTION: {
    TITLE: 'Dette URL-link er allerede i brug i en anden fane.',
    SUBTITLE: 'Luk den anden fane, og genindlæs derefter denne side igen.',
  },

  FORMS: {
    NO_COUNTRIES_FOUND: 'Ingen lande fundet',
    NO_RESULTS_FOUND: 'Ingen resultater fundet',
    CHOOSE_FILES: 'Vælg filer',
    NO_FILE_CHOSEN: 'Ingen fil valgt',
    SELECT_AN_OPTION: 'Vælg en mulighed',
    SEARCH: 'Søg...',
    ERRORS: {
      REQUIRED: 'Dette felt er påkrævet',
      EMAIL: 'Indtast venligst en gyldig e-mailadresse',
      MIN_LENGTH: 'Minimumlængde er {{requiredLength}} tegn',
      MAX_LENGTH: 'Maksimal længde er {{requiredLength}} tegn',
      INVALID: 'Ugyldig værdi',
      ONLY_NUMBERS: 'Kun tal er tilladt',
      FILE_TYPE: 'Filen skal være jpeg, jpg, bmp, gif eller pdf',
      CPR_ONLY_DIGITS: 'CPR må kun indeholde cifre',
      CPR_LENGTH: 'CPR skal være præcis 10 cifre',
      CPR_INVALID: 'CPR-nummeret er ikke gyldigt',
      BANK_ACCOUNT_REG_ONLY_NUMERIC: 'Kun tal er tilladt',
      BANK_ACCOUNT_REG_FOUR_DIGITS: 'Registreringsnummer skal være præcis 4 cifre',
      CVR_ONLY_NUMERIC: 'Kun tal er tilladt',
      CVR_EIGHT_DIGITS: 'CVR skal være præcis 8 cifre',
    },
  },

  CALENDAR: {
    DAYS: {
      SUN: 'Søn',
      MON: 'Man',
      TUE: 'Tir',
      WED: 'Ons',
      THU: 'Tor',
      FRI: 'Fre',
      SAT: 'Lør',
    },
    MONTHS: {
      JANUARY: 'Januar',
      FEBRUARY: 'Februar',
      MARCH: 'Marts',
      APRIL: 'April',
      MAY: 'Maj',
      JUNE: 'Juni',
      JULY: 'Juli',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'Oktober',
      NOVEMBER: 'November',
      DECEMBER: 'December',
    },
  },

  SIGNATURE: {
    CLEAR_SIGNATURE: 'Ryd Signatur',
    YOUR_SIGNATURE: 'Din Signatur',
    AGREEMENT_DOCUMENT_TITLE: 'Aftaledokument til underskrift',
    AGREEMENT_DOCUMENT_DESCRIPTION: 'Ved at underskrive aftalen angiver jeg, at jeg har læst og accepteret indholdet af det følgende aftaledokument. Min underskrift er bindende.',
    FORM_DESCRIPTION: 'Ved at underskrive blanketten angiver jeg, at jeg har læst og accepteret indholdet af den følgende blanket. Min underskrift er bindende.',
    SIGN_HERE: 'Underskriv her',
  },

  STEPS: {
    LOGIN_SHARED_SECRET: 'Log ind med aftalt kode',
    LOGIN_OTP: 'Log ind med midlertidig engangskode',
    LOGIN_EID: 'Log ind',
    LOGIN_MITID: 'Log ind med MitID',
    REVIEW_FILES: 'Gennemse filer',
    REVIEW_DOCUMENTS: 'Læs dokumenter',
    REVIEW_FORMS: 'Læs blanketter',
    ORDER_QUESTIONS: 'Besvar spørgsmål',
    SIGN: 'Aftaledokument til underskrift',
    SIGN_FORM: 'Blanket til underskrift',
    RECEIPT: 'Kvittering',
    DOWNLOAD: 'Download',
    CPR: 'CPR-verifikation',
    FILE: 'Filupload',
    FILES: 'Sikker ePost',
    APPROVER_REVIEW_FILES: 'Ordre indbakke',
    APPROVER_SIGN: 'Aftaledokumenter til underskrift',
  },
  LOGIN_OTP: {
    INSTRUCTION: 'Indtast venligst SMS-koden, du har modtaget på din mobil. Koden er sendt til telefon nr. {{ phoneNumber }}.',
    OTP_CODE: 'Engangskode',
    OTP_EXPIRED: 'Engangskoden er udløbet. Anmod venligst om en ny.',
    RESEND_OTP: 'Send kode igen',
    RESEND_OTP_IN: 'Send kode igen om',
    OTP_PHONE_INSTRUCTION: 'Indtast venligst den 6-cifrede kode, der er sendt til din telefon.',
  },
  LOGIN_SHARED_SECRET: {
    INSTRUCTION: 'For at bekræfte din identitet og få adgang til dine dokumenter, skal du indtaste den delte adgangskode, som du har modtaget fra {{ senderName }}.',
    SHARED_SECRET: 'Aftalt kode',
    SHARED_SECRET_ERROR: 'Den aftalte kode stemmer ikke overens',
    SHARED_SECRET_REQRUIRED: 'Den aftalte adgangskode er påkrævet',
  },

  LOGIN_EID: {
    POPUP_ALERT: 'Deaktivér venligst din pop op-blokering og prøv igen.',
    ORIGIN_MISMATCH: 'Sikkerhedsadvarsel: Identitetsudbyderens oprindelse stemmer ikke overens. Prøv venligst igen.',
    SUCCESS: 'Du er nu logget ind.',
    AUTHENTICATED: 'Godkendelse gennemført.',
    ERROR: 'Login mislykkedes. Prøv venligst igen.',
    INSTRUCTION: 'For at få sikker adgang til at underskrive dine dokumenter, skal du logge ind med dit eID. Vælg en login-metode nedenfor for at fortsætte.',
    SINGLE_PROVIDER_INSTRUCTION: 'For at få sikker adgang til at underskrive dine dokumenter, skal du logge ind for at fortsætte.',
    FORM_INSTRUCTION: 'For at få sikker adgang til at underskrive din blanket, skal du logge ind med dit eID. Vælg en login-metode nedenfor for at fortsætte.',
    FORM_SINGLE_PROVIDER_INSTRUCTION: 'For at få sikker adgang til at underskrive din blanket, skal du logge ind for at fortsætte.',
    CPR_INSTRUCTION: 'Du bedes logge ind med dit MitID/eID for at bekræfte din identitet. Vælg en login-metode nedenfor for at fortsætte.',
    CPR_SINGLE_PROVIDER_INSTRUCTION: 'Du bedes logge ind med dit MitID/eID for at bekræfte din identitet.',
    PROVIDERS: {
      mitid: 'Log ind med MitID',
      'mitid-business': 'Log ind med MitID Erhverv',
      bankid_no: 'Log ind med Norsk BankID',
      swedish_bank_id: 'Log ind med Svensk BankID',
      default: 'Log ind med {{name}}',
    },
    MITID_BUSINESS_SUBTITLE: 'Kan benyttes hvis din virksomhed/forening har tilsluttet sig MitID Erhverv',
  },

  REVIEW_FILES: {
    INSTRUCTION: 'Du bedes hente eller åbne alle vedhæftninger.\nNår alt er hentet eller åbnet, vil afsender modtage en notifikation om dette\nNår alle vedhæftninger er hentet eller åbnet, kan du gå videre til din kvittering',
    SHOW_ALL_SIGNERS: 'Status for underskrivere',
    ATTACHMENTS: 'Vedhæftninger',
    DESCRIPTION: 'Se hvilke personer, der har underskrevet, og hvilke der mangler.',
    NO_SIGNERS_FOUND: 'Ingen underskrivere fundet',
    FILES_LEFT: 'Du mangler at læse de resterende {{count}}, dokument(er).',
    FILES_READ_ALL: 'Du har læst alle dokumenterne. Du kan nu fortsætte til underskrift.',
    FORM_FILES_LEFT: 'Du mangler at læse de resterende {{count}} blanket(ter).',
    FORM_FILES_READ_ALL: 'Du har læst alle blanketterne. Du kan nu fortsætte til underskrift.',
    GO_TO_RECEIPT: 'Gå til kvittering',
    CONTINUE: 'Fortsæt',
    FILES: 'Dokumenter',
  },

  REVIEW_DOCUMENTS: {
    INSTRUCTION: 'Du bedes åbne og læse alle dokumenter og eventuelle bilag herunder.',
    FORM_INSTRUCTION: 'Du bedes åbne og læse alle blanketter og eventuelle bilag herunder.',
    FILES: 'Dokumenter',
    FORM_FILES_ONE: 'Blanket',
    FORM_FILES_MANY: 'Blanketter',
    SHOW_ALL_SIGNERS: 'Status for underskrivere',
    ATTACHMENTS: 'Bilag',
    DESCRIPTION: 'Se hvilke personer, der har underskrevet, og hvilke der mangler.',
    NO_SIGNERS_FOUND: 'Ingen underskrivere fundet',
  },

  SIGN_DOCUMENT: {
    INSTRUCTION: 'Du bedes åbne og læse alle dokumenter og eventuelle bilag herunder.',
  },

  ORDER_QUESTIONS: {
    INSTRUCTION: 'Udfyld venligst nedenstående felter.',
    LOADING: 'Indlæser spørgsmål...',
    SAVING: 'Gemmer...',
    REQUIRED_FIELDS_WARNING: 'påkrævede spørgsmål er ikke besvaret',
    GOTO_FIRST_UNANSWERED: 'Gå til første',
    INPUTS_NOT_EQUAL: 'Det indtastede er ikke ens',
    ENTER_FIELD_PLACEHOLDER: 'Indtast {{field}}',
    ENTER_ZIP_CODE_PLACEHOLDER: 'Indtast postnummer',
    ENTER_EMAIL_PLACEHOLDER: 'Indtast e-mailadresse',
    ENTER_VALUE_PLACEHOLDER: 'Indtast værdi',
    YES: 'Ja',
    NO: 'Nej',
    ERRORS: {
      REQUIRED: 'Dette felt er påkrævet.',
      EMAIL: 'Indtast en gyldig e-mailadresse.',
      CPR: 'Indtast et gyldigt CPR-nummer.',
      CVR_ONLY_NUMERIC: 'Kun tal er tilladt.',
      CVR_EIGHT_DIGITS: 'CVR skal være præcis 8 cifre.',
      BANK_REGISTRATION_NUMBER_ONLY_NUMERIC: 'Kun tal er tilladt.',
      BANK_REGISTRATION_NUMBER_FOUR_DIGITS: 'Registreringsnummer skal være præcis 4 cifre.',
      PATTERN: 'Ugyldigt format.',
      VALUE_NOT_ALLOWED: 'Denne værdi kan ikke bruges. Indtast venligst en anden.',
      BACKEND_INVALID: 'Værdien kunne ikke gemmes. Prøv venligst igen.',
      FILE_TYPE: 'Denne filtype er ikke tilladt.',
      INVALID: 'Ugyldig værdi.',
    },
  },

  RECEIPT: {
    SUCCESS_HEADING: 'Din underskrift er gennemført',
    FILES_ORDER_SUCCESS_HEADING: 'Dine filer er hentet',
    FILES_ORDER_SUCCESS_MESSAGE: 'Der er blevet sendt en mail til',
    SUCCESS_MESSAGE: 'Vi har sendt en kvittering for din underskrift til',
    SUCCESS_COMPLETION: 'Først når alle har underskrevet, vil du modtage en mail med et link til det underskrevne dokument',
    SUCCESS_COMPLETION_SINGLE_SIGNER: 'En mail med et link til det/de underskrevne dokument(er) er sendt til din mail',
    FORM_SUCCESS_COMPLETION: 'Først når alle har underskrevet, vil du modtage en mail med et link til den underskrevne blanket',
    FORM_SUCCESS_COMPLETION_SINGLE_SIGNER: 'En mail med et link til den underskrevne blanket er sendt til din mail',
    REFERENCE_ID: 'Reference ID',
    LOGGED_OUT_MESSAGE: 'Du er automatisk blevet logget ud og kan nu lukke dette vindue.',
    ALL_SIGNERS: 'Alle underskrivere',
    ALL_SIGNERS_SINGLE_SIGNER: 'Underskriver',
    DOWNLOAD_MESSAGE: 'Bemærk venligst, at du har 90 dage til at downloade din kopi af aftaledokumentet. Alt du skal gøre er at følge linket i den mail, vi har sendt dig.',
    FORM_DOWNLOAD_MESSAGE: 'Bemærk venligst, at du har 90 dage til at downloade din kopi af blanketten. Alt du skal gøre er at følge linket i den mail, vi har sendt dig.',
    FILES_ORDER_DOWNLOAD_MESSAGE: ', som indeholder en kvittering og et link til dine filer.\nBemærk at du har 90 dage til at hente din kopi af indholdet. Det eneste du skal gøre er, at følge linket i mailen der er sendt til dig.',
    FILES_ORDER_REJECTED_HEADING: 'Ordren er annulleret',
    FILES_ORDER_REJECTED_MESSAGE: 'Der er sendt en besked til afsender.',
    REJECTED_BY_OWNER_TITLE: 'Ordre annulleret af ejer',
    REJECTED_BY_OWNER_MESSAGE: 'Denne ordre er blevet annulleret af ejeren.',
    REJECTED_BY_SIGNER_TITLE: 'Ordre annulleret - underskrift afvist',
    REJECTED_BY_SIGNER_MESSAGE: 'Denne ordre er blevet annulleret, da en af underskriverne har afvist at underskrive.',
    NO_SIGNATURE_REQUIRED_HEADING: 'Succes',
    NO_SIGNATURE_REQUIRED_REJECTED_HEADING: 'Ordren er annulleret',
    NO_SIGNATURE_REQUIRED_MESSAGE: 'En e-mail er blevet sendt til',
    NO_SIGNATURE_REQUIRED_REJECTED_MESSAGE: 'Der er sendt en besked til afsender.',
    NO_SIGNATURE_REQUIRED_MESSAGE_SUFFIX: ', den indeholder en kvittering og et link til aftaledokumentet. Du har 90 dage til at hente din kopi af aftalen ved at følge linket i e-mailen.',
  },

  STATUS: {
    SIGNED: 'Underskrevet',
    RECEIVED: 'Modtaget',
    PENDING: 'Afventer',
    REJECTED: 'Afvist',
    LOCKED: 'Låst',
  },

  NOT_FOUND: {
    TITLE: 'Side ikke fundet',
    DESCRIPTION: 'Den side, du leder efter, eksisterer ikke, eller underskriftslinket er ugyldigt.',
  },

  NO_SUCH_APPROVER: {
    TITLE: 'Intern underskriver ikke genkendt',
    DESCRIPTION: 'Der findes ingen interne underskrivere der matcher det benyttede MitId.',
  },

  NO_ACCESS_CPR: {
    TITLE: 'CPR-tjekket kunne ikke gennemføres',
    DESCRIPTION: 'Det anvendte MitID stemmer ikke overens med det CPR-nummer, der skal tjekkes. Du bedes kontakte {{senderName}} og oplyse referencenr. {{referenceId}}.',
  },

  ARCHIVED: {
    TITLE: 'Signeringsordren er ikke tilgængelig',
    DESCRIPTION: 'Den signeringsordre du forsøger at tilgå, er desværre ikke længere tilgængelig. 90 dage efter sidste underskriver har afgivet sin underskrift, slettes signeringsordren og tilhørende dokumenter.',
  },

  ALREADY_SIGNED: {
    TITLE: 'Allerede underskrevet',
    DESCRIPTION: 'Denne underskriftsordre er allerede underskrevet.',
  },

  CPR_ALREADY_SIGNED: {
    TITLE: 'CPR-ordre allerede underskrevet',
    DESCRIPTION: 'Denne CPR-underskriftsordre er allerede gennemført.',
  },

  VERIFY_ERROR: {
    TITLE: 'Bekræftelse fejlede',
    DESCRIPTION: 'Den benyttede identitet til underskrivning stemmer ikke overens med den, der kræves til denne ordre.',
  },

  ORDER_MISMATCH: {
    TITLE: 'Ordre stemmer ikke overens',
    DESCRIPTION: 'Underskriftsordren stemmer ikke overens med den aktuelle session. Luk venligst andre faner og prøv igen.',
  },

  PSEUDONYM_DISALLOWED: {
    TITLE: 'Pseudonym-brugere er ikke tilladt',
    DESCRIPTION: 'Kunden tillader ikke underskrivning med en pseudonym identitet.',
  },

  EXPIRED: {
    TITLE: 'Tidsfristen for signeringsordren er udløbet',
    DESCRIPTION: 'Afsenderen af denne signeringsordre - {{documentReference}} - har sat en tidsfrist for hvornår denne signeringsordre senest kan underskrives. Tidsfristen er nu udløbet.',
    SUB_DESCRIPTION: 'Kontakt evt. afsender {{senderName}}, hvis du er i tvivl eller tror, der er sket en fejl.',
    MORE_INFO: 'Klik her for mere information',
    INFO_TITLE: 'Hvorfor er der en tidsfrist?',
    INFO: 'Alle signeringsordrer har en tidsfrist. På den måde kan afsender sikre sig, at signeringsordren underskrives inden for afsenders valgte kriterier.',
    SUB_TITLE: 'Hvad gør jeg nu?',
    SUB_INFO: 'Afsender er blevet gjort opmærksom på, at en eller flere parter ikke har underskrevet inden for tidsfristen. Du kan enten afvente, at afsender kontakter dig, eller kontakte afsender på ny.',
  },

  STEP_LOCKED: {
    TITLE: 'Dette trin er i øjeblikket låst',
    DESCRIPTION: 'Dette underskriftstrin er låst og kan ikke gennemføres på nuværende tidspunkt. Kontakt venligst afsenderen for yderligere oplysninger.',
  },

  UNEXPECTED: {
    TITLE: 'Der opstod en uventet fejl',
    DESCRIPTION: 'Der opstod en uventet fejl under behandlingen af din anmodning. Prøv venligst igen senere.',
  },

  STEP_NOT_AVAILABLE: {
    TITLE: 'Dette trin er ikke tilgængeligt endnu',
    DESCRIPTION: 'Dette underskriftstrin er ikke tilgængeligt endnu. Vent venligst på, at det forrige trin er gennemført, før du fortsætter.',
  },

  UNAUTHORIZED: {
    TITLE: 'Der opstod en fejl',
    DESCRIPTION: 'Vi kunne ikke verificere signerings sessionen. Venligst prøv igen via linket du har modtaget eller kontakt afsender.',
  },

  ERRORS: {
    UNAUTHORIZED: 'Du er ikke autoriseret til at få adgang til denne ressource',
    BAD_REQUEST: 'Ugyldig anmodning. Kontroller venligst dine indtastninger',
    FORBIDDEN: 'Adgang til denne ressource er forbudt',
    NOT_FOUND: 'Den ønskede ressource kunne ikke findes',
    SERVER_ERROR: 'Der opstod en fejl på serveren. Prøv venligst igen senere',
    UNKNOWN_ERROR: 'Der opstod en uventet fejl. Prøv venligst igen',
    SESSION_EXPIRED: 'Din session er udløbet. Log venligst ind igen.',
  },

  RECEIPT_CPR: {
    SUCCESS_HEADING: 'Din identifikation er nu bekræftet.',
    SUCCESS_MESSAGE: 'Vi har sendt en kvittering for dit CPR-tjek til',
    REJECTED_HEADING: 'Signeringen afslået',
    REJECTED_MESSAGE: 'Der er sendt en besked til',
  },

  CPR_CHECK: {
    INSTRUCTION: 'Indtast venligst dit CPR-nummer',
    CPR_NUMBER: 'CPR-nummer',
    CPR_NUMBER_PLACEHOLDER: 'Indtast dit CPR-nummer',
    HEALTH_INSURANCE_CARD: 'Upload et foto af dit sygesikringskort',
    PHOTO_ID: 'Upload en kopi af dit foto-ID - fx pas eller kørekort',
    FILE_HINT: "Understøttede formater: 'png', 'jpg', 'bmp'. Maks filstørrelse: 10 MB.",
    PROTECTED_CPR_PHOTO_ID_REQUIRED: 'Da du har navne- og adressebeskyttelse kan vi ikke verificere din information. Du bedes venligst udfylde nedenstående felter.',
  },

  REJECT_MODAL: {
    TITLE: 'Vil du afvise denne ordre?',
    REASON_PLACEHOLDER: 'Skriv din årsag til afvisning',
    CONFIRM: 'Bekræft afvisning',
  },

  DOWNLOAD_STEP: {
    HEADING: 'Download dine dokumenter',
    DESCRIPTION: 'Du kan nu downloade en kopi af dine signerede dokumenter. Dokumenterne er tilgængelige i 90 dage fra den dato, de blev underskrevet. Klik på download knappen for at gemme dem lokalt på din computer',
    DOWNLOAD_BUTTON: 'Download kopi',
    LOGOUT_BUTTON: 'Log ud',
    LOGGED_OUT_HEADING: 'Du er nu logget ud',
    LOGGED_OUT_DESCRIPTION: 'Tak for din brug af Esignatur. Vi ser frem til at se dig igen.',
  },

  LOGOUT_MODAL: {
    TITLE: 'Log ud?',
    DESCRIPTION: 'Er du sikker på, at du vil logge ud? Eventuelle ændringer vil gå tabt.',
    CONFIRM: 'Log ud',
  },

  REJECTION_SUCCESS_MODAL: {
    TITLE: 'Ordren blev afvist',
    DESCRIPTION: 'Denne ordre er blevet afvist',
    CONTINUE: 'Fortsæt',
  },

  APPROVER_RECEIPT: {
    SUCCESS_HEADING: 'Dine underskrifter blev succesfuldt gennemført.',
    SUCCESS_MESSAGE: 'Du er automatisk blevet logget ud og kan nu lukke dette vindue.',
  },

  SUPPORT: {
    CONTACT: 'Kontakt os via e-mail:',
  },
};
